import React from 'react'

import ReportTable from '../report_table'
import { formatReportDate } from '../helpers'

// port of cowebapp analytics/components/data_pulse/report_member_table.js (identical to form_guard in cowebapp)
const MemberTableOrg = (props) => {

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.breakdown)
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []

    props.memberData.forEach(data => {
      const name = data.name?.credits_used || 0
      const email = data.email?.credits_used || 0
      const phone = data.phone?.credits_used || 0
      const total = name + email + phone

      if (total > 0) {
        tableData.push({
          date: data.date,
          name,
          email,
          phone,
          total
        })
      }
    })

    return tableData
  }

  const data = getTableData()
  const formatNumber = cell => cell === 0 ? '-' : Number(cell).toLocaleString()
  const colWidth = { width: '20%' }

  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      formatter: dateFormatter,
      style: colWidth,
    },
    {
      dataField: 'total',
      text: 'Total Credits',
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
    },
    {
      dataField: 'email',
      text: 'Email Validation Credits',
      style: colWidth,
      align: 'right',
      formatter: formatNumber,
    },
    {
      dataField: 'phone',
      text: 'Phone Validation Credits',
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'name',
      text: 'Name Validation Credits',
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
    }
  ]

  return (
    <div>
      <ReportTable
        wrapperClasses="table-member-report table-responsive"
        keyField="date"
        data={data}
        columns={columns}
        noDataIndication={noDataIndication}
        hideHeader
      />
    </div>
  )
}

export default MemberTableOrg
